//#region libraries
import React, { useEffect } from 'react';
//redux
import { useSelector, useDispatch } from 'react-redux';
import { selectUserDb, lastNotificationRead } from '_redux/slices/main-screen/user';
import { getPosts, selectPosts } from '_redux/slices/notifications/notifications'
//external component
import ReactMarkdown from 'react-markdown';
import { Row, Col, Container } from 'react-bootstrap';
//custom component
import { NewScreen, Title } from "_atoms";
//styles
import { Colors } from '_styles';
import styles from './markdown.module.css'
//#endregion

const UpdatesPage = () => {
  //#region redux
  const dispatch = useDispatch();
  const dbUser = useSelector(selectUserDb)
  const posts = useSelector(selectPosts);
  //#endregion

  useEffect(() => {
    dispatch(lastNotificationRead(dbUser.firebaseId));
    dispatch(getPosts());
  }, []);

  // Here we want to show a the list of updates in ./updates containing a number of markdown files e.g ./updates/2023-08-15.md and ./updates/2023-08-14.md
  // We want to show the list of updates in reverse chronological order
  // We want to show the list of updates in a list with the date as the title and the content as the body
  // The title is the name of the file in the format YYYY-MM-DD

  // {console.log('content', content)}
  return (

    <NewScreen>

      <Row>
        {/* LOGO */}

        <Col>
          <Title subtitle={'Update Hub'} description={"Here you can find the latest changes to the portal"} />
        </Col>
      </Row>

      <Row className='mt-3'>
        <div className={styles.container}>
          {Object.entries(posts).map(([date, content], index) => (
            <div className={styles.updateCard} key={index}>

              <div style={{ display: 'flex' }}>

                <p style={{
                  color: Colors.PRM_LIGHT_BLUE,
                  fontSize: 22, fontWeight: '300', opacity: 0.8, marginLeft: 12, marginTop: 12
                }}>{date.replace('.md', '')}</p>
                <div>

                </div>
              </div>

              <Container>
                <ReactMarkdown
                  className={styles.reactMarkDown}
                  children={content}>
                </ReactMarkdown>
              </Container>

            </div>
          ))}
        </div>
      </Row>
    </NewScreen>


  );
};

export default UpdatesPage;
